/* 30 Role-Play scenarios — one per day, matched to vocabulary theme.
   Each level uses the same 30 topic shells but AI adapts vocabulary difficulty.
*/
export const ROLEPLAY_TOPICS = [
  {
    day: 1,
    scenario: 'First Meeting',
    scenarioAr: 'أول لقاء',
    icon: '🤝',
    setting: 'You just arrived at a new school / university on the first day.',
    settingAr: 'وصلت لأول مرة لمدرسة / جامعة جديدة',
    aiRole: 'Alex, a friendly student sitting next to you',
    aiRoleAr: 'أليكس — طالب جالس بجانبك',
    aiPersonality: 'warm, welcoming, curious about the new student',
    starterLine: "Hi there! Is this your first day here too? My name is Alex — what's yours?",
    starterLineAr: 'مرحباً! هل هذا أول يوم لك أيضاً؟ اسمي أليكس — وأنت؟',
    focusWords: ['Hello', 'Name', 'I am', 'Student', 'Teacher', 'Friend'],
    tips: ['استخدم تعبير "Nice to meet you"', 'اسأل "Where are you from?"', 'عرّف بنفسك بوضوح']
  },
  {
    day: 2,
    scenario: 'Family Photo',
    scenarioAr: 'صورة عائلية',
    icon: '👨‍👩‍👧‍👦',
    setting: 'You are showing your family photo on your phone to a new friend.',
    settingAr: 'تُريهم صورة عائلتك على الجوال',
    aiRole: 'Sara, a curious new friend',
    aiRoleAr: 'سارة — صديقة جديدة فضولية',
    aiPersonality: 'interested, asks many questions about your family',
    starterLine: "Oh wow, is that your family? They look so nice! Who is this person?",
    starterLineAr: 'واو، هذه عائلتك؟ يبدون رائعين! من هذا الشخص؟',
    focusWords: ['Mother', 'Father', 'Brother', 'Sister', 'Family', 'Old', 'Young'],
    tips: ['صف العمر: "He is 45 years old"', 'استخدم: "She is my..."', 'استخدم: "He looks..."']
  },
  {
    day: 3,
    scenario: 'Clothes Shopping',
    scenarioAr: 'التسوق للملابس',
    icon: '👗',
    setting: 'You are at a clothing store looking for a new outfit.',
    settingAr: 'أنت في محل ملابس تبحث عن طقم جديد',
    aiRole: 'Sam, a helpful shop assistant',
    aiRoleAr: 'سام — بائع متعاون',
    aiPersonality: 'helpful, professional, asks about preferences in colors and sizes',
    starterLine: "Welcome! Can I help you find something today? What are you looking for?",
    starterLineAr: 'أهلاً وسهلاً! هل أستطيع مساعدتك في إيجاد شيء اليوم؟ ماذا تبحث عن؟',
    focusWords: ['Color', 'Red', 'Blue', 'Big', 'Small', 'Clothes', 'Buy'],
    tips: ['اسأل عن الألوان المتاحة', 'صف ما تريد بدقة', 'استخدم: "Do you have...?"']
  },
  {
    day: 4,
    scenario: 'At the Café',
    scenarioAr: 'في المقهى',
    icon: '☕',
    setting: 'You are at a cozy café ordering food and drinks.',
    settingAr: 'أنت في مقهى تطلب طعاماً وشراباً',
    aiRole: 'Jordan, a friendly café waiter',
    aiRoleAr: 'جوردان — نادل مقهى ودود',
    aiPersonality: 'welcoming, knows the menu well, offers recommendations',
    starterLine: "Good morning! Welcome to The Green Cup Café. What would you like to order today?",
    starterLineAr: 'صباح الخير! أهلاً في مقهى The Green Cup. ماذا تودّ أن تطلب اليوم؟',
    focusWords: ['Coffee', 'Tea', 'Water', 'Sandwich', 'Please', 'Thank you', 'How much'],
    tips: ['استخدم: "Can I have...?"', 'اسأل عن السعر: "How much is...?"', 'اشكر النادل']
  },
  {
    day: 5,
    scenario: 'House Tour',
    scenarioAr: 'جولة في البيت',
    icon: '🏠',
    setting: 'You just moved into a new apartment and your neighbor comes to say hello.',
    settingAr: 'انتقلت لشقة جديدة وجارك يأتي ليرحب بك',
    aiRole: 'Riley, your friendly new neighbor',
    aiRoleAr: 'رايلي — جارك الجديد الودود',
    aiPersonality: 'curious and friendly, offers to help with moving',
    starterLine: "Hi neighbor! I heard you just moved in. I'm Riley from next door. How are you settling in?",
    starterLineAr: 'مرحباً جار! سمعت أنك انتقلت للتو. أنا رايلي من الشقة المجاورة. كيف حال استقرارك؟',
    focusWords: ['House', 'Room', 'Kitchen', 'Bedroom', 'Living room', 'Big', 'Beautiful'],
    tips: ['صف منزلك: "My apartment has..."', 'استخدم: "There is / There are"', 'اسأل عن الحي']
  },
  {
    day: 6,
    scenario: 'Daily Routine',
    scenarioAr: 'الروتين اليومي',
    icon: '⏰',
    setting: 'You and a friend are comparing your morning routines.',
    settingAr: 'أنت وصديق تقارنان روتين صباحكما',
    aiRole: 'Pat, your university classmate',
    aiRoleAr: 'بات — زميلك في الجامعة',
    aiPersonality: 'casual, talks fast, always running late for class',
    starterLine: "Dude, I woke up at 8:45 and class starts at 9! What about you — when do you usually wake up?",
    starterLineAr: 'يا صديقي، صحيت الساعة 8:45 والكلاس يبدأ الساعة 9! وأنت — متى تصحى عادةً؟',
    focusWords: ['Wake up', 'Breakfast', 'Go to school', 'Morning', 'Always', 'Usually', 'Never'],
    tips: ['استخدم أفعال المضارع البسيط', 'صف روتينك خطوة بخطوة', 'استخدم: "First... Then... Finally..."']
  },
  {
    day: 7,
    scenario: 'At the Doctor',
    scenarioAr: 'عند الطبيب',
    icon: '🏥',
    setting: 'You are at a doctor\'s clinic because you are not feeling well.',
    settingAr: 'أنت في عيادة طبيب لأنك لا تشعر بصحة جيدة',
    aiRole: 'Dr. Morgan, a kind and thorough doctor',
    aiRoleAr: 'الدكتور مورغان — طبيب لطيف ودقيق',
    aiPersonality: 'professional but warm, asks detailed questions about symptoms',
    starterLine: "Good afternoon. Please have a seat. So, what seems to be the problem today?",
    starterLineAr: 'مساء الخير. تفضل بالجلوس. إذاً، ما هي المشكلة اليوم؟',
    focusWords: ['Sick', 'Head', 'Pain', 'Fever', 'Medicine', 'Better', 'Hospital'],
    tips: ['صف الأعراض بوضوح', 'استخدم: "I feel..." / "It hurts when..."', 'اسأل عن الدواء']
  },
  {
    day: 8,
    scenario: 'Weather Talk',
    scenarioAr: 'حديث عن الطقس',
    icon: '☀️',
    setting: 'You bump into a neighbor while both of you are checking the weather outside.',
    settingAr: 'تلتقي بجار بينما تتفقدان الطقس في الخارج',
    aiRole: 'Chris, your chatty neighbor',
    aiRoleAr: 'كريس — جارك الثرثار',
    aiPersonality: 'loves talking about weather, has plans that depend on it',
    starterLine: "Can you believe this weather? I was planning a picnic today! What do you think — will it rain?",
    starterLineAr: 'هل تصدق هذا الطقس؟ كنت أخطط لنزهة اليوم! ماذا تعتقد — هل ستمطر؟',
    focusWords: ['Hot', 'Cold', 'Rain', 'Sun', 'Wind', 'Today', 'Tomorrow'],
    tips: ['صف الطقس بالتفصيل', 'استخدم: "It is going to..."', 'تحدث عن خططك بناءً على الطقس']
  },
  {
    day: 9,
    scenario: 'At the Bus Station',
    scenarioAr: 'في محطة الحافلات',
    icon: '🚌',
    setting: 'You are at a bus station trying to get to the city center.',
    settingAr: 'أنت في محطة حافلات تحاول الوصول إلى وسط المدينة',
    aiRole: 'An information desk officer named Kim',
    aiRoleAr: 'كيم — موظف مكتب المعلومات',
    aiPersonality: 'efficient, helpful, speaks clearly and gives good directions',
    starterLine: "Hello, can I help you? Are you looking for a particular bus or destination?",
    starterLineAr: 'مرحباً، هل أستطيع مساعدتك؟ هل تبحث عن حافلة معينة أو وجهة محددة؟',
    focusWords: ['Bus', 'Train', 'Ticket', 'Where', 'How far', 'Left', 'Right'],
    tips: ['اسأل عن الوجهة والوقت', 'استخدم: "How do I get to...?"', 'اطلب توضيح الاتجاهات']
  },
  {
    day: 10,
    scenario: 'At the Library',
    scenarioAr: 'في المكتبة',
    icon: '📚',
    setting: 'You are at the school library looking for books for a project.',
    settingAr: 'أنت في مكتبة المدرسة تبحث عن كتب لمشروع',
    aiRole: 'Ms. Lee, the helpful librarian',
    aiRoleAr: 'الآنسة لي — أمينة المكتبة المتعاونة',
    aiPersonality: 'knowledgeable, organized, passionate about books and learning',
    starterLine: "Welcome to the library! Looking for something specific? I can help you find it.",
    starterLineAr: 'أهلاً بك في المكتبة! هل تبحث عن شيء محدد؟ أستطيع مساعدتك في إيجاده.',
    focusWords: ['Book', 'Read', 'Study', 'Help', 'Find', 'Information', 'Project'],
    tips: ['اشرح موضوع مشروعك', 'اسأل عن قسم الكتب المناسب', 'اشكر على المساعدة']
  },
  {
    day: 11,
    scenario: 'Planning a Trip',
    scenarioAr: 'التخطيط لرحلة',
    icon: '✈️',
    setting: 'You and a friend are excitedly planning your first trip together.',
    settingAr: 'أنت وصديق تخططان لأول رحلة مشتركة بحماس',
    aiRole: 'Max, your adventurous best friend',
    aiRoleAr: 'ماكس — أصدق أصدقائك المغامر',
    aiPersonality: 'very excited, has big ideas, sometimes unrealistic but fun',
    starterLine: "Okay I've been thinking — what if we go somewhere really cool this summer? I was thinking maybe Paris or Tokyo?!",
    starterLineAr: 'حسناً كنت أفكر — ماذا لو ذهبنا لمكان رائع هذا الصيف؟ كنت أفكر في باريس أو طوكيو؟!',
    focusWords: ['Travel', 'Hotel', 'Flight', 'Visit', 'Exciting', 'Plan', 'Beach'],
    tips: ['ناقش خيارات الوجهة', 'تحدث عن الميزانية والوقت', 'استخدم will للمستقبل']
  },
  {
    day: 12,
    scenario: 'Job Interview',
    scenarioAr: 'مقابلة عمل',
    icon: '💼',
    setting: 'You are in a job interview for a position you really want.',
    settingAr: 'أنت في مقابلة عمل لوظيفة تريدها جداً',
    aiRole: 'Ms. Park, the HR manager conducting the interview',
    aiRoleAr: 'آنسة بارك — مدير الموارد البشرية',
    aiPersonality: 'professional, evaluating carefully, asks behavioral questions',
    starterLine: "Thank you for coming in today. Please take a seat. So, can you tell me a little about yourself?",
    starterLineAr: 'شكراً لحضورك اليوم. تفضل بالجلوس. هل يمكنك أن تخبرني قليلاً عن نفسك؟',
    focusWords: ['Work', 'Experience', 'Skills', 'Team', 'Responsible', 'Goal', 'Achieve'],
    tips: ['قدّم نفسك بثقة', 'تحدث عن مهاراتك وخبراتك', 'اسأل أسئلة في النهاية']
  },
  {
    day: 13,
    scenario: 'Restaurant Reservation',
    scenarioAr: 'حجز في مطعم',
    icon: '🍽️',
    setting: 'You are calling a restaurant to make a reservation for a special occasion.',
    settingAr: 'تتصل بمطعم لحجز طاولة لمناسبة خاصة',
    aiRole: 'The restaurant receptionist',
    aiRoleAr: 'موظف استقبال المطعم',
    aiPersonality: 'polite and efficient, needs all the details for the booking',
    starterLine: "Good evening, thank you for calling La Bella Vista. How can I help you tonight?",
    starterLineAr: 'مساء الخير، شكراً لاتصالك بـ La Bella Vista. كيف يمكنني مساعدتك الليلة؟',
    focusWords: ['Reserve', 'Table', 'People', 'Date', 'Time', 'Special', 'Occasion'],
    tips: ['حدد التاريخ والوقت وعدد الأشخاص', 'اذكر أي طلبات خاصة', 'اطلب تأكيد الحجز']
  },
  {
    day: 14,
    scenario: 'Technology Problem',
    scenarioAr: 'مشكلة تقنية',
    icon: '💻',
    setting: 'Your laptop stopped working right before an important deadline and you call tech support.',
    settingAr: 'توقف لابتوبك قبل موعد مهم وتتصل بالدعم التقني',
    aiRole: 'Alex, a tech support specialist',
    aiRoleAr: 'أليكس — متخصص دعم تقني',
    aiPersonality: 'patient, methodical, walks through troubleshooting step by step',
    starterLine: "Tech support, this is Alex. What seems to be the issue with your device today?",
    starterLineAr: 'دعم تقني، معك أليكس. ما هي المشكلة مع جهازك اليوم؟',
    focusWords: ['Computer', 'Screen', 'Internet', 'Password', 'Update', 'Restart', 'Problem'],
    tips: ['صف المشكلة بدقة', 'اتبع تعليمات المتخصص', 'استخدم: "It says..." / "The screen shows..."']
  },
  {
    day: 15,
    scenario: 'Apartment Hunting',
    scenarioAr: 'البحث عن شقة',
    icon: '🔑',
    setting: 'You are viewing an apartment and asking the landlord questions.',
    settingAr: 'تتفقد شقة وتسأل المالك أسئلة',
    aiRole: 'Mr. Davis, the apartment landlord',
    aiRoleAr: 'السيد ديفيس — مالك الشقة',
    aiPersonality: 'business-like, knows the apartment well, negotiable on some things',
    starterLine: "Welcome! Here's the apartment. It's two bedrooms and was renovated last year. What would you like to know?",
    starterLineAr: 'أهلاً! هذه الشقة. غرفتا نوم وتم تجديدها العام الماضي. ماذا تريد أن تعرف؟',
    focusWords: ['Rent', 'Bedroom', 'Bathroom', 'Included', 'Lease', 'Neighborhood', 'Quiet'],
    tips: ['اسأل عن الإيجار والخدمات المشمولة', 'اسأل عن الحي والمواصلات', 'ناقش شروط العقد']
  },
  {
    day: 16,
    scenario: 'Studying Together',
    scenarioAr: 'الدراسة معاً',
    icon: '📖',
    setting: 'You and a classmate are preparing together for an important exam.',
    settingAr: 'أنت وزميل تستعدان معاً لامتحان مهم',
    aiRole: 'Jamie, your hardworking study partner',
    aiRoleAr: 'جيمي — شريكك في الدراسة المجتهد',
    aiPersonality: 'focused but stressed, needs to explain things to understand them',
    starterLine: "Okay, so I get chapters 1 to 3 but chapter 4 is killing me. Do you understand the main argument?",
    starterLineAr: 'حسناً، أفهم الفصول من 1 إلى 3 لكن الفصل الرابع يُربكني. هل تفهم الحجة الرئيسية؟',
    focusWords: ['Understand', 'Explain', 'Chapter', 'Difficult', 'Important', 'Review', 'Practice'],
    tips: ['اشرح مفاهيم بكلماتك', 'اسأل لتوضيح ما لا تفهمه', 'ناقش استراتيجية المراجعة']
  },
  {
    day: 17,
    scenario: 'At the Bank',
    scenarioAr: 'في البنك',
    icon: '🏦',
    setting: 'You need to open a bank account or solve a banking issue.',
    settingAr: 'تحتاج لفتح حساب بنكي أو حل مشكلة مصرفية',
    aiRole: 'Taylor, a bank customer service representative',
    aiRoleAr: 'تايلور — موظف خدمة عملاء البنك',
    aiPersonality: 'professional, precise, needs verification of identity and details',
    starterLine: "Good morning! How can I assist you today? Do you have an appointment or is this a walk-in?",
    starterLineAr: 'صباح الخير! كيف أستطيع مساعدتك اليوم؟ هل لديك موعد مسبق أم بدون موعد؟',
    focusWords: ['Account', 'Money', 'Transfer', 'Card', 'Interest', 'Balance', 'Withdraw'],
    tips: ['اشرح حاجتك بوضوح', 'اسأل عن الرسوم والشروط', 'تحقق من الإجراءات المطلوبة']
  },
  {
    day: 18,
    scenario: 'Giving Directions',
    scenarioAr: 'إعطاء الاتجاهات',
    icon: '🗺️',
    setting: 'A tourist stops you on the street asking for directions to a famous landmark.',
    settingAr: 'سائح يوقفك في الشارع يسأل عن الطريق لمعلم مشهور',
    aiRole: 'A confused but friendly tourist from Canada',
    aiRoleAr: 'سائح كندي مرتبك لكن ودود',
    aiPersonality: 'lost, very grateful for help, asks clarifying questions',
    starterLine: "Excuse me! Sorry to bother you, but I'm completely lost. Can you help me find the main museum? My phone battery died!",
    starterLineAr: 'عذراً! آسف على الإزعاج، لكنني ضائع تماماً. هل يمكنك مساعدتي في إيجاد المتحف الرئيسي؟ بطارية هاتفي ماتت!',
    focusWords: ['Turn', 'Left', 'Right', 'Straight', 'Block', 'Corner', 'Next to'],
    tips: ['أعطِ اتجاهات واضحة خطوة بخطوة', 'استخدم علامات مرجعية', 'تأكد أن الآخر فهمك']
  },
  {
    day: 19,
    scenario: 'Social Media Discussion',
    scenarioAr: 'نقاش عن وسائل التواصل',
    icon: '📱',
    setting: 'You and a friend are having a debate about the impact of social media.',
    settingAr: 'أنت وصديق تتناقشان عن تأثير وسائل التواصل الاجتماعي',
    aiRole: 'Jordan, a friend who has strong opinions',
    aiRoleAr: 'جوردان — صديق له آراء قوية',
    aiPersonality: 'opinionated, likes to debate, open to changing mind if given good arguments',
    starterLine: "I'm seriously thinking about deleting all my social media. I think it's making everyone more anxious. Do you agree?",
    starterLineAr: 'أفكر جدياً في حذف كل حسابات التواصل الاجتماعي الخاصة بي. أعتقد أنها تجعل الجميع أكثر قلقاً. هل توافق؟',
    focusWords: ['Social media', 'Opinion', 'Agree', 'Disagree', 'Because', 'However', 'Impact'],
    tips: ['عبّر عن رأيك بوضوح', 'استخدم: "I think..." / "In my opinion..."', 'ادعم رأيك بأمثلة']
  },
  {
    day: 20,
    scenario: 'Cooking Class',
    scenarioAr: 'درس طبخ',
    icon: '👨‍🍳',
    setting: 'You are at a cooking class and the chef is teaching you a new recipe.',
    settingAr: 'أنت في درس طبخ والشيف يعلمك وصفة جديدة',
    aiRole: 'Chef Mia, a passionate cooking instructor',
    aiRoleAr: 'الشيف ميا — مدربة طبخ شغوفة',
    aiPersonality: 'enthusiastic about food, very encouraging, loves when students try new things',
    starterLine: "Welcome to my class! Today we're making a classic Italian pasta from scratch. Have you ever made pasta before?",
    starterLineAr: 'أهلاً بكم في صفي! اليوم سنصنع معكرونة إيطالية كلاسيكية من الصفر. هل سبق وصنعت معكرونة من قبل؟',
    focusWords: ['Cook', 'Recipe', 'Ingredients', 'Mix', 'Add', 'Taste', 'Delicious'],
    tips: ['اسأل عن المكونات وكمياتها', 'اتبع التعليمات بالترتيب', 'استخدم أفعال الأمر']
  },
  {
    day: 21,
    scenario: 'Academic Presentation',
    scenarioAr: 'عرض أكاديمي',
    icon: '🎓',
    setting: 'You are presenting your research paper to your professor and classmates.',
    settingAr: 'تقدم ورقتك البحثية أمام أستاذك وزملائك',
    aiRole: 'Professor Chen, a rigorous but fair academic',
    aiRoleAr: 'البروفيسور تشن — أكاديمي صارم لكن عادل',
    aiPersonality: 'asks tough but fair questions, wants clear arguments and evidence',
    starterLine: "Thank you for your presentation. It was interesting. My first question is: what is the central argument of your paper?",
    starterLineAr: 'شكراً لعرضك. كان مثيراً للاهتمام. سؤالي الأول: ما هي الحجة المحورية في ورقتك؟',
    focusWords: ['Argue', 'Evidence', 'Research', 'Conclude', 'Furthermore', 'However', 'Therefore'],
    tips: ['قدم حجتك الرئيسية بوضوح', 'استشهد بالأدلة', 'استخدم روابط منطقية']
  },
  {
    day: 22,
    scenario: 'Music Festival',
    scenarioAr: 'مهرجان موسيقي',
    icon: '🎵',
    setting: 'You are at an outdoor music festival and you meet a fellow music lover.',
    settingAr: 'أنت في مهرجان موسيقي خارجي وتقابل عاشق موسيقى',
    aiRole: 'River, an enthusiastic music fan',
    aiRoleAr: 'ريفر — عاشق موسيقى متحمس',
    aiPersonality: 'passionate, opinionated about music, wants to share what they love',
    starterLine: "This band is incredible, right?! I've been following them for years. What kind of music do you usually listen to?",
    starterLineAr: 'هذه الفرقة رائعة، صحيح؟! أتابعهم منذ سنوات. ما نوع الموسيقى الذي تستمع إليه عادةً؟',
    focusWords: ['Music', 'Band', 'Song', 'Rhythm', 'Feel', 'Emotion', 'Performance'],
    tips: ['عبّر عن ذوقك الموسيقي', 'تحدث عن تجربتك العاطفية مع الموسيقى', 'قارن أنواع الموسيقى']
  },
  {
    day: 23,
    scenario: 'History Museum',
    scenarioAr: 'متحف التاريخ',
    icon: '🏛️',
    setting: 'You are at a history museum and a guide shares fascinating stories.',
    settingAr: 'أنت في متحف تاريخي ومرشد يشارك قصصاً رائعة',
    aiRole: 'Guide Sam, a passionate history enthusiast',
    aiRoleAr: 'المرشد سام — متحمس للتاريخ',
    aiPersonality: 'loves stories, knows every artifact, makes history come alive',
    starterLine: "Welcome! This exhibit focuses on a period that changed everything. What do you know about this era already?",
    starterLineAr: 'أهلاً بك! هذا المعرض يتمحور حول حقبة غيّرت كل شيء. ماذا تعرف بالفعل عن هذه الحقبة؟',
    focusWords: ['History', 'Memory', 'Past', 'Remember', 'Witness', 'Legacy', 'Generation'],
    tips: ['أظهر فضولك', 'اسأل عن التفاصيل والقصص', 'اربط الماضي بالحاضر']
  },
  {
    day: 24,
    scenario: 'Hospital Volunteer',
    scenarioAr: 'متطوع في المستشفى',
    icon: '🏥',
    setting: 'You are volunteering at a hospital and speaking with a patient.',
    settingAr: 'تتطوع في مستشفى وتتحدث مع مريض',
    aiRole: 'An elderly patient named Eleanor who loves to talk',
    aiRoleAr: 'إليانور — مريضة مسنّة تحب الحديث',
    aiPersonality: 'philosophical, has lived a rich life, wants to share wisdom',
    starterLine: "Oh, a visitor! Please sit. You know, at my age you start thinking about what a life well-lived really means. Do you think about these things?",
    starterLineAr: 'أوه، زائر! تفضل بالجلوس. تعلم، في عمري تبدأ بالتفكير في معنى الحياة الجيدة حقاً. هل تفكر في هذه الأمور؟',
    focusWords: ['Life', 'Death', 'Meaning', 'Legacy', 'Family', 'Regret', 'Grateful'],
    tips: ['استمع بتعاطف', 'اطرح أسئلة فلسفية بلطف', 'شارك تأملاتك الخاصة']
  },
  {
    day: 25,
    scenario: 'Speed Date',
    scenarioAr: 'موعد سريع (Speed Date)',
    icon: '💕',
    setting: 'You are at a speed-dating event and have 4 minutes to make a connection.',
    settingAr: 'أنت في حدث speed-dating ولديك 4 دقائق لتكوين ارتباط',
    aiRole: 'Casey, someone you\'ve just sat across from',
    aiRoleAr: 'كيسي — الشخص الجالس أمامك للتو',
    aiPersonality: 'charming, witty, asks deep questions despite the time limit',
    starterLine: "Hi! Okay, we have four minutes. I like to skip the small talk. Tell me: what's one thing that makes you come alive?",
    starterLineAr: 'مرحباً! حسناً، لدينا أربع دقائق. أحب تخطي الحديث السطحي. أخبرني: ما الشيء الذي يجعلك تشعر بالحيوية؟',
    focusWords: ['Connection', 'Feeling', 'Care', 'Passion', 'Honest', 'Genuine', 'Future'],
    tips: ['كن صادقاً وأصيلاً', 'اسأل أسئلة عميقة', 'عبّر عن اهتماماتك الحقيقية']
  },
  {
    day: 26,
    scenario: 'Work-Life Balance',
    scenarioAr: 'التوازن بين العمل والحياة',
    icon: '⚖️',
    setting: 'You are in a team meeting discussing a new policy about remote work and work hours.',
    settingAr: 'أنت في اجتماع فريق يناقش سياسة جديدة للعمل عن بعد وساعات العمل',
    aiRole: 'Your direct manager, Robin',
    aiRoleAr: 'مديرك المباشر، روبن',
    aiPersonality: 'open to discussion but has company goals to meet, pragmatic',
    starterLine: "Thanks everyone for joining. I wanted to discuss how we can better support work-life balance while still meeting our targets. What are your thoughts?",
    starterLineAr: 'شكراً للجميع على الحضور. أردت مناقشة كيف يمكننا دعم التوازن بين العمل والحياة مع الوفاء بأهدافنا. ما آراؤكم؟',
    focusWords: ['Work', 'Balance', 'Flexible', 'Productive', 'Burnout', 'Rights', 'Negotiate'],
    tips: ['اعرض حجة مدروسة', 'استخدم أمثلة', 'كن محترماً لكن حازماً في دفاعك عن حقوقك']
  },
  {
    day: 27,
    scenario: 'Interfaith Dialogue',
    scenarioAr: 'حوار بين الأديان',
    icon: '🕌',
    setting: 'You are at a community interfaith dialogue event and share respectful views.',
    settingAr: 'أنت في فعالية حوار بين الأديان وتشارك وجهات نظر محترمة',
    aiRole: 'A theology student named Noah',
    aiRoleAr: 'نوح — طالب لاهوت',
    aiPersonality: 'thoughtful, curious, deeply respectful of different perspectives',
    starterLine: "I find that these conversations are so rare and so needed. Can I ask what role does spirituality or faith play in your daily life — or does it?",
    starterLineAr: 'أجد أن هذه المحادثات نادرة جداً وضرورية جداً. هل يمكنني أن أسأل ما الدور الذي تلعبه الروحانية أو الإيمان في حياتك اليومية — أم لا تلعب دوراً؟',
    focusWords: ['Belief', 'Sacred', 'Respect', 'Tradition', 'Secular', 'Community', 'Meaning'],
    tips: ['كن محترماً ومنفتحاً', 'ميّز بين الوصف والحكم', 'اسأل لتفهم لا لتجادل']
  },
  {
    day: 28,
    scenario: 'Political Debate',
    scenarioAr: 'نقاش سياسي',
    icon: '🗳️',
    setting: 'You are in a university political debate club discussing democracy and populism.',
    settingAr: 'أنت في نادي نقاش سياسي جامعي يناقش الديمقراطية والشعبوية',
    aiRole: 'The debate moderator, Dr. Mills',
    aiRoleAr: 'الدكتور ميلز — مدير النقاش',
    aiPersonality: 'neutral moderator who pushes all sides to justify their arguments',
    starterLine: "Tonight's motion: 'Populist movements are a threat to democracy, not a symptom of its failure.' You have the floor — which side do you take and why?",
    starterLineAr: 'موضوع الليلة: "الحركات الشعبوية تهديد للديمقراطية، لا أعراض لفشلها." لديك الكلمة — أي جانب تأخذ ولماذا؟',
    focusWords: ['Democracy', 'Populism', 'Represent', 'Crisis', 'Legitimate', 'Polarize', 'Reform'],
    tips: ['خذ موقفاً واضحاً', 'ادعم حجتك بأمثلة', 'أقرّ بنقاط قوة الجانب الآخر']
  },
  {
    day: 29,
    scenario: 'AI Ethics Panel',
    scenarioAr: 'لجنة أخلاقيات الذكاء الاصطناعي',
    icon: '🤖',
    setting: 'You are on a panel discussing the ethics and future of artificial intelligence.',
    settingAr: 'أنت في لجنة تناقش أخلاقيات ومستقبل الذكاء الاصطناعي',
    aiRole: 'A tech journalist named Sam who challenges your views',
    aiRoleAr: 'سام — صحفي تقني يتحدى وجهات نظرك',
    aiPersonality: 'sharp, skeptical, asks the hard questions, represents public concern',
    starterLine: "So you're the expert here. My readers want to know: should ordinary people be scared of AI? What are the real risks we're not talking about?",
    starterLineAr: 'إذاً أنت الخبير هنا. يريد قرائي أن يعرفوا: هل يجب على الناس العاديين أن يخافوا من الذكاء الاصطناعي؟ ما هي المخاطر الحقيقية التي لا نتحدث عنها؟',
    focusWords: ['Alignment', 'Bias', 'Surveillance', 'Consciousness', 'Risk', 'Regulate', 'Humanity'],
    tips: ['ميّز بين المخاطر القريبة والبعيدة', 'استخدم أمثلة واقعية', 'أظهر التعقيد دون خوف أو إفراط في الاطمئنان']
  },
  {
    day: 30,
    scenario: 'Translation Project',
    scenarioAr: 'مشروع ترجمة',
    icon: '🌍',
    setting: 'You are meeting with a publisher to discuss translating an important literary work.',
    settingAr: 'أنت تلتقي بناشر لمناقشة ترجمة عمل أدبي مهم',
    aiRole: 'Elena, a senior editor at an international publishing house',
    aiRoleAr: 'إيلينا — محررة أولى في دار نشر دولية',
    aiPersonality: 'sophisticated, cares deeply about preserving meaning, not just words',
    starterLine: "Thank you for meeting with me. I've read your translation sample and I have one big question: how are you going to handle the untranslatable cultural concepts in chapter three?",
    starterLineAr: 'شكراً لاجتماعك معي. قرأت عينة ترجمتك ولدي سؤال كبير: كيف ستتعامل مع المفاهيم الثقافية غير القابلة للترجمة في الفصل الثالث؟',
    focusWords: ['Translate', 'Meaning', 'Culture', 'Untranslatable', 'Foreignize', 'Domesticate', 'Hermeneutics'],
    tips: ['ناقش استراتيجية الترجمة', 'تحدث عن التوازن بين الأمانة والطلاقة', 'استخدم مصطلحات فينوتي وبنيامين']
  },
]

export function getRolePlayTopic(dayId) {
  return ROLEPLAY_TOPICS.find(t => t.day === dayId) || ROLEPLAY_TOPICS[0]
}
